import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
} from '@material-ui/core'
import Description from '@mui/icons-material/Description'
import { useEffect, useState } from 'react'
import { middleofficeRequest } from '../../../axios'

export const AGDoc = (props) => {
  const { coproprietaire, key } = props
  const [documents, setDocuments] = useState([])

  const fetchData = async () => {
    const res = await middleofficeRequest.get(
      `middleoffice/coowners/${coproprietaire.id}/documents`
    )
    setDocuments(res.data)
  }

  useEffect(() => {
    fetchData()
  }, [coproprietaire])

  return (
    <Box component={Paper} key={key} padding={'20px'}>
      <List dense={true} component="nav">
        {Object.keys(documents)
          .filter(
            (k) => documents[k].tags && documents[k].tags.indexOf('AG') !== -1
          )
          .map((k) => (
            <ListItem
              key={documents[k].url}
              component="a"
              target="_blank"
              href={documents[k].url}
              rel="noreferrer"
              button
            >
              <ListItemIcon>
                <Description />
              </ListItemIcon>
              <ListItemText primary={documents[k].libelle} />
            </ListItem>
          ))}
      </List>
    </Box>
  )
}
export default AGDoc
